<template>
  <div class="customers">
    <v-container class="pa-2 d-flex flex-column">
    <template>
      <v-card class="mt-4 ma-2">
        <v-card-title>
          <h4 class="subheading grey--text">Φίλτρα</h4>
        </v-card-title>
        <v-card-text>
          <v-row>
            <v-col cols=2 sm=4 md=2>
              <v-text-field
                v-model="ypoloipo"
                prepend-icon="mdi-greater-than-or-equal"
                prefix="€"
                label="Υπόλοιπο"
                />

            </v-col>
            <v-col cols=4 sm=4>
               <v-switch
                v-model="overdue"
                label="Καθυστερημένα"
               ></v-switch>
            </v-col>
            <v-spacer/>
            <v-col cols=4 sm="4">
            <v-chip label outlined>
              {{
              $tocurr(filteredBalance)
              }}
            </v-chip>

            </v-col>
            <v-spacer/>
            <v-dialog
              v-model="dialog"
              persistent
              max-width="600px"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  v-if="isAdmin"
                  color="primary"
                  dark
                  v-bind="attrs"
                  small
                  v-on="on"
                >
                <v-icon>mdi-plus</v-icon>
                </v-btn>
              </template>
              <v-card>
                <v-card-title>
                  <span class="text-h5">Στοιχεία Πελάτη</span>
                </v-card-title>
                <v-card-text>
                  <v-container>
                    <v-row>
                      <v-col
                        cols="12"
                      >
                        <v-text-field
                          label="Επωνυμία*"
                          v-model="customerContact.name"
                          required
                        ></v-text-field>
                      </v-col>
                      <v-col
                        cols="12"
                        sm="6"
                      >
                        <v-text-field
                          label="Τίτλος επιχείρισης"
                          v-model="customerContact.CommerTitle"
                          hint="Εμπορική ονομασία"
                          persistent-hint
                          required
                        ></v-text-field>
                      </v-col>
                      <v-col
                        cols="12"
                        sm="6"
                      >
                        <v-text-field
                          label="Customer ID*"
                          v-model="customerContact.Cid"
                          required
                        ></v-text-field>
                      </v-col>
                      <v-col cols="6">
                        <v-text-field
                          label="Α.Φ.Μ.*"
                          v-model="customerContact.Afm"
                          required
                        >
                       <template v-slot:append-outer>
                        <v-btn
                          color="blue darken-1"
                          text
                          @click="fetchInfo"
                        >
                        <v-icon>mdi-account-arrow-down</v-icon>
                        </v-btn>
                       </template>
                        </v-text-field>
                      </v-col>
                      <v-col
                        cols="12"
                      >
                        <v-text-field
                          label="Διεύθυνση"
                          v-model="customerContact.Address"
                          hint="Πλήρης Διεύθυνση"
                        ></v-text-field>
                      </v-col>
                      <v-col cols="8"
                             sm="6">
                        <v-text-field
                          label="ΔΟΥ*"
                          v-model="customerContact.DoyDescr"
                          required
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12"
                             sm="6">
                        <v-text-field
                          label="Περιοχή*"
                          v-model="customerContact.City"
                          required
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12">
                        <v-text-field
                          label="Τηλέφωνο*"
                          v-model="customerContact.Telephone"
                          required
                        ></v-text-field>
                      </v-col>
                      <v-col
                        cols="12"
                      >
                        <v-select
                          :items=firmActs
                          label="Εμπορική Δραστηριότητα"
                          v-model="customerContact.FirmActDescr"
                          required
                        ></v-select>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col
                        cols="6"
                      >
                        <v-text-field
                          label="Διεύθυνση Ηλεκτρονικού Ταχυδρομείου"
                          :rules="[rules.email]"
                          v-model="customerContact.Email"
                        ></v-text-field>
                      </v-col>
                    </v-row>
                  </v-container>
                  <small>* Υποχρεωτικά πεδία</small>
                </v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn
                    color="blue darken-1"
                    text
                    @click="dialog = false"
                  >
                    Κλεισιμο
                  </v-btn>
                  <v-btn
                    color="blue darken-1"
                    text
                    @click="createCustomer"
                  >
                    Αποθηκευση
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </v-row>
          <v-row>
            <v-col
                v-for="status in [1,-1,-2,-3, -4]"
                :key="status"
                cols="auto"
                class="d-flex justify-center"
              >
                <v-chip
                  class="pa-4"
                  :outlined="gradeSelected(status)"
                  :color="getColor(status)"
                  @click="toggleGrade(status)"
                >
                <v-icon v-if="status==1" small left>mdi-star-circle</v-icon>
                <v-icon v-if="status==-2" small left>mdi-cash</v-icon>
                <v-icon v-if="status==-3" small left>mdi-cash-clock</v-icon>
                <v-icon v-if="status==-4" small left>mdi-cancel</v-icon>
                    <span class="mx-2">{{ getGradeDesc(status) }}</span>
                </v-chip>
              </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </template>
      <template>
        <v-card class="mt-4 ma-2">
          <v-card-title>
            <h1 class="mr-2 subheading grey--text">Πελάτες</h1>
            <v-btn @click="refresh_data" icon><v-icon>mdi-refresh</v-icon></v-btn>
            <v-spacer/>
            <v-chip v-if="isAdmin" label outlined>
              {{
              tocurr(balance)
              }}
              ({{
              tocurr(repairbalance)
              }})
            </v-chip>
            <v-spacer/>
            <v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              label="Search"
              single-line
              clearable
              hide-details
            ></v-text-field>
          </v-card-title>
          <v-card-text>
          <v-data-table :headers="showHeaders" :items="filteredCustomers" :search="search"
          item-key="Name"
          class="elevation-1"
          :loading="loading"
          sort-by="Balance"
          sort-desc
          :items-per-page=15
          :height="$vuetify.breakpoint.height*0.6"
          loading-text="Loading... Please wait"
          @click:row="clickrow"
          @current-items="updateBalance"
          >
          <template v-slot:item.Rid="{ item }">
            <v-chip outlined :color="getColor(item.Status)">
              <v-icon v-if="item.Status==1" small left>mdi-star-circle</v-icon>
              <v-icon v-if="item.Status==-2" small left>mdi-cash</v-icon>
              <v-icon v-if="item.Status==-3" small left>mdi-cash-clock</v-icon>
              <v-icon v-if="item.Status==-4" small left>mdi-cancel</v-icon>
              {{ item.Rid }}
            </v-chip>
          </template>

           <template v-slot:item.info.telephone="{ item }">
              <span v-if="isNaN(item.info.telephone)">-</span>
              <span v-else>{{ item.info.telephone }}</span>
          </template>
          <template v-slot:item.info.afm="{ item }">
            <span v-if="isNaN(item.info.afm)">000000000</span>
            <span v-else>{{
              new String(Number(item.info.afm).toFixed()).padStart(9, "0")
            }}</span>
          </template>
          <template v-slot:item.Balance="{ item }">
            {{
              new Intl.NumberFormat("el-GR", {
                style: "currency",
                currency: "EUR",
                }).format(item.Balance)
            }}
          </template>
            <template v-slot:item.RepairBalance="{ item }">
            {{
              new Intl.NumberFormat("el-GR", {
                style: "currency",
                currency: "EUR",
                }).format(item.RepairBalance)
            }}
          </template>
          <template v-slot:expanded-item="{ headers, item }">
            <td :colspan="headers.length">More info about {{ item.name }}</td>
          </template>

          <template v-slot:item.actions="{ item }">
            <v-btn
              class="mr-2"
              icon
              small
              :to="'customer/' + item.Id + '/info'"
            >
              <v-icon>mdi-information-variant</v-icon>
            </v-btn>
            <v-btn
              class="mr-2"
              icon
              small
              :to="'customer/' + item.Id + '/invoices'"
            >
              <v-icon>mdi-file-document-multiple</v-icon>
            </v-btn>
            <v-btn
              class="mr-2"
              icon
              small
              @click.stop="getBook(item)"
            >
              <v-icon>mdi-microsoft-excel</v-icon>
            </v-btn>
            <v-btn
              class="mr-2"
              icon
              small
              @click="showPaymDialog(item)"
            >
              <v-icon>mdi-cash-register</v-icon>
            </v-btn>
          </template>
        </v-data-table>
        <payment-dialog :cid.sync="dialogcid" :dialog.sync="paymdialog" apipath="customers/debits" />
          </v-card-text>
        </v-card>
      </template>
    </v-container>
  </div>
</template>

<script>
import PaymentDialog from '../components/PaymentDialog.vue';

export default {
  components: {
    PaymentDialog,
  },
  computed: {
    // filteredBalance () {
    //   return this.sumTotals(this.filteredCustomers);
   //   return this.sumTotals(this.customers.filter(function (e) {
   //     if (this.overdue) {
   //     if (this.due.includes(e.customer_id) && e.balance.balance > this.ypoloipo) return true;
   //     } else {
   //       return e.balance.balance > this.ypoloipo;
   //     }
   //   }, this));
    // },
    isAdmin() {
        if (!this.$store.state.authentication.user) return false;
        return this.$store.state.authentication.user.scopes.includes("income");
    },
    filteredCustomers() {
      // Use this computed property in your template to display customers
      if (this.selectedGrades.length>=1) {
        return this.customers.filter(c => this.selectedGrades.includes(c.Status));
      }
      return this.customers;
    },
    showHeaders() {
        let headers = this.isAdmin ? this.headers : this.headers.filter(h=> !(["Balance", "actions"]).includes(h.value))
        if (this.$vuetify.breakpoint.smAndDown) {
            return headers.filter(h => !(["Afm", "Address"]).includes(h.value));
        } else {
            return headers;
        }
    },
  },
  data() {
    return {
      tableOptions: { sortBy: 'Balance', descending: true, itemsPerPage: 20 },
      balance: 0.0,
      rules:  {
        email: value => {
            const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
            return pattern.test(value) || 'Invalid e-mail.'
          },
      },
      customers: [],
      due: [],
      dialog: false,
      paymdialog: false,
      dialogcid: 0,
      loading: true,
      overdue: false,
      selectedGrades: [],
      search: "",
      ypoloipo: 0.0,
      repairbalance: 0.0,
      filteredBalance: 0,
      customerContact: {
        name: "",
        Address: "",
        City: "",
        DoyDescr: "",
        Telephone: "",
        FirmActDescr: "",
        Cid: "",
      },
      firmActs: [],
      headers: [
        { text: "A/A",
          align: "start",
          value: "Rid",
      //    filter: (value) => {
      //      //if (!this.overdue) return value;
      //      //if (this.due.includes(value)) return value;
      //      return value;
      //    }
        },
        {
          text: "Πελάτης",
          align: "start",
          //sortable: false,
          value: "Name",
          width: "40%",
        },
        { text: "ΑΦΜ", value: "Afm" },
        { text: "Διεύθυνση", value: "Address" },
        { text: "Τηλέφωνο", value: "Telephone", width: "10%" },
        { text: "Υπόλοιπο", value: "Balance", align: "end",
          filter: (value) => {
            if (this.ypoloipo == 0) return true
            return value >= this.ypoloipo;
          }
        },
        { text: "Καρτέλα", value: "RepairBalance", align: "end"},
        // { text: "Status", value: "balance.currency" },
        { text: "Actions", value: "actions", sortable: false, width: "10%" },
        //{ text: '', value: 'data-table-expand' },
      ],
    };
  },
  async created() {
    this.initialise();
  },
  methods: {
    async initialise() {
      // GET request using fetch with async/await
      try {
        const response = await this.$api.get("/customers/");
        this.customers = response.data;
        //console.log(this.customers);
        // const resp = await this.$api.get("/balance/");
        this.balance = this.sumTotals(this.customers);
        this.repairbalance = this.sumRepairs(this.customers);
        //let due = await this.$api.get("/isoverdue/");
        //this.due = due.data;
        this.due = this.sumTotals(this.customers);

        this.loading = false;
      } catch (error) {
        console.error(error);
      }
    },
    updateBalance (items) {
      this.filteredBalance = this.sumTotals(items);
    },
    showPaymDialog(item) {
      this.dialogcid = item.Id;
      this.paymdialog = true;
    },
    // eslint-disable-next-line no-unused-vars
    clickrow(item, _) {
      //this.$router.push('customer/'+item.customer_id)
    },
    sumTotals(items) {
      // sum data in give key (property)
      return items.reduce((a, b) => a + (b.Balance || 0), 0);
    },
    sumRepairs(items) {
      // sum data in give key (property)
      return items.reduce((a, b) => a + (b.RepairBalance || 0), 0);
    },
    tocurr(value) {
      return new Intl.NumberFormat("el-GR", {
        style: "currency",
        currency: "EUR",
      }).format(value);
    },
    sortBy(prop) {
      this.customers.sort((a, b) => (a[prop] < b[prop] ? -1 : 1));
    },
    gradeSelected (grade) {
      if (this.selectedGrades.length == 0) return true;
      return !this.selectedGrades.includes(grade);
    },
    toggleGrade(grade) {
        if (this.selectedGrades.includes(grade)) {
          this.selectedGrades = this.selectedGrades.filter(m => m !== grade);
        } else {
            this.selectedGrades.push(grade);
        }
    },
    getGradeDesc(grade) {
      switch (grade) {
        case 1:
          return "Καλός"; // Green (good)
        case 0:
          return "Ουδέτερος"; // Grey (neutral)
        case -1:
          return "Ενοχλητικός/Τσίπης"; // Orange (annoying)
        case -2:
          return "Μόνο μετρητοίς"; // Amber (should pay in cash)
        case -3:
          return "Μόνο προκαταβολή"; // Red (should prepay)
        case -4:
          return "Μαύρη Λίστα"; // Black (blacklist)
        default:
          return "Κανονικός"; // Default to grey if out of range
      }
    },
    /**
     * Returns a color code based on the customer grade.
     * @param {number} grade - Grade from -4 (blacklist) to 1 (good)
     * @returns {string} - Color code
    */
    getColor(grade) {
      switch (grade) {
        case 1:
          return "green"; // Green (good)
        case 0:
          return "primary"; // Blue (neutral)
        case -1:
          return "#FBC02D"; // Orange (annoying)
        case -2:
          return "amber"; // Amber (should pay in cash)
        case -3:
          return "red"; // Red (should prepay)
        case -4:
          return '#757575'; // Black (blacklist)
        default:
          return 'primary'; // Default to grey if out of range
      }
    },
    async refresh_data () {
      this.loading = true;
      const response = await this.$api.get("/customers/", { clearCache: true });
      this.customers = response.data;
      this.$store.customers = response.data;
      this.balance = this.sumTotals(this.customers);
      this.due = this.sumTotals(this.customers);
      this.loading = false;
    },
    async fetchInfo() {
      var response = await this.$api.get("/vat-info/"+this.customerContact.Afm);
      var contact = response.data;
      this.customerContact.name = contact.Onomasia;
      this.customerContact.Address = contact.Address;
      this.customerContact.Afm = contact.Afm;
      this.customerContact.CommerTitle = contact.CommerTitle;
      this.customerContact.DoyDescr = contact.DoyDescr;
      this.customerContact.City = contact.PostalAreaDescription;
      this.firmActs = [];
      for (var i in contact.FirmActivity) {
        this.firmActs.push(contact.FirmActivity[i].FirmActDescr);
      }
    },
    async createCustomer() {
      let customer = this.customerContact;
      var response = await this.$api.post("/customers/", customer);
      console.log(response);
      this.dialog = false;
    },

    async getBook(item) {
      // let color = window.confirm("Χρωματισμός γραμμών");
      //let color = true;

      const token = await this.$api.get('/customers/'+item.Id+'/book', {params: {color: false}});
      console.log(token)
      const response = await this.$api.get('/customers/book',
          { responseType: "blob",
            params: {token: token.data.token}});
      let url = window['URL'].createObjectURL(response.data)
      var a = document.createElement('a')
      a.href = url
        a.download = item.Cid + ' - ΚΑΡΤΕΛΑ ΠΕΛΑΤΗ.xlsx';
      a.click()
      a.remove()
      setTimeout(() => window.URL.revokeObjectURL(url), 100)

    }


  },
};
</script>

<style>
.project.complete {
  border-left: 4px solid #3cd1c2;
}
.project.ongoing {
  border-left: 4px solid #ffaa2c;
}
.project.overdue {
  border-left: 4px solid #f83e70;
}
.v-chip.complete {
  background: #3cd1c2;
}
.v-chip.ongoing {
  background: #ffaa2c;
}
.v-chip.overdue {
  background: #f83e70;
}
</style>
